/**
 * Created by sergeys on 06.04.2017.
 */
export default class DictionaryStr<U>{
    [ index: string ]: U
}

export class DictionaryNum<U>{
    [ index: number ]: U
}


// WEBPACK FOOTER //
// ./src/app/models/dictionary.ts